import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/tailwind.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./Redux/store";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_KEY_2}>
        <App />
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();

if (module.hot) {
  module.hot.accept();
}
